import React from "react";
import { TransactionHistoryDetailsContainer } from "../../../containers";

const DistributionHistoryDetails = (props) => {
  return <TransactionHistoryDetailsContainer {...props} />;
};

export default DistributionHistoryDetails;
